/**
 * Account rules. The browser checks them so the operator hears about a
 * mistake before sending it; the server enforces them.
 */

/** Short enough to guess is short enough to refuse: these accounts can destroy sites. */
export const PASSWORD_MIN = 12;

export const DISPLAY_NAME_MAX = 80;
